import { useCallback } from "react";

import { createResolverFactory, useQuery } from ".";

export function useGetFieldType() {
  const queryFactory = useCallback(() => {
    const query = `
    query getFieldTypes {
      fieldTypes {
        id
        text
        showOptions
      }
    }`;

    const resolver = ({ data: { fieldTypes } }) => {
      return fieldTypes;
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const { loading, data, error } = useQuery(queryFactory, {
    options: { cached: true },
  });

  return {
    loadingFieldType: loading,
    error: error
      ? error[0]?.message ||
        "Failed to load the list of available field types, please retry or contact support for assistance"
      : "",
    fieldTypes: data,
  };
}

export default useGetFieldType;
